import React from "react"
import {Drawer, Form, Input, Row, Col, Select, Button, Switch} from "antd"
import {compose} from 'recompose';
import {connect} from "react-redux";
import {withRouter} from "react-router";
import {bindActionCreators} from "redux";
import * as SelectionActions from "../../reducers/selection_builder";
import PropTypes from "prop-types";

const {Option} = Select;

class SelectionCreationDrawer extends React.Component {

    onSubmit = () => {
        this.props.form.validateFields((errors, values) => {
            if (!errors) {
                this.props.insert(values);
                this.props.toggleVisibility()
            }
        })
    };


    static propTypes = {
        insert: PropTypes.func.isRequired
    };


    render() {
        const {visible, toggleVisibility, toEdit, customers, type, form: {getFieldDecorator}} = this.props;
        return <Drawer title="Update Selection" width={720} placement="right" visible={visible} style={{
            height: 'calc(100% - 55px)',
            overflow: 'auto',
            paddingBottom: 53,
        }} onClose={toggleVisibility}>
            <Form>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Name">
                            {getFieldDecorator('name', {
                                initialValue: toEdit.name,
                                rules: [{required: true, message: 'Please enter a Selection name'}],
                            })(<Input placeholder="Please enter a Selection name"/>)}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Customer">
                            {getFieldDecorator('customerCode', {
                                initialValue: toEdit.customer,
                                rules: [{required: true, message: 'Please select a customor'}],
                            })(
                                <Select placeholder="Customor">
                                    {customers.map((user) => (
                                        <Option value={user.code}>{user.name}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Type">
                            {getFieldDecorator('type', {
                                initialValue: toEdit.type,
                                rules: [{required: true, message: 'Please select a type'}],
                            })(
                                <Select  placeholder="Type">
                                    {type.map((user) => (
                                        <Option value={user.id}>{user.description}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Active">
                            {getFieldDecorator('active', {
                                valuePropName: 'checked',
                                initialValue: toEdit.active
                            })(
                                <Switch/>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="ID">
                            {getFieldDecorator('id', {
                                initialValue: toEdit.id,
                                rules: [{required: true, message: 'Please enter a ID'}],
                            })(<Input disabled={true} placeholder="Please enter a ID"/>)}
                        </Form.Item>
                    </Col>

                </Row>
                <div
                    style={{
                        position: 'absolute',
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e8e8e8',
                        padding: '10px 16px',
                        textAlign: 'right',
                        left: 0,
                        background: '#fff',
                        borderRadius: '0 0 4px 4px',
                    }}
                >
                    <Button
                        style={{
                            marginRight: 8,
                        }}
                        onClick={toggleVisibility}
                    >
                        Cancel
                    </Button>
                    <Button onClick={this.onSubmit} type="primary">Submit</Button>
                </div>
            </Form>
        </Drawer>
    }

}

const mapStateToProps = state => ({
    populate: state.selection_builder.populate,
});

const mapDispatchToProps = dispatch => ({
    insert: bindActionCreators(SelectionActions, dispatch).updateSelections,
});

export default compose(
    withRouter,
    Form.create(),
    connect(mapStateToProps, mapDispatchToProps),
)(SelectionCreationDrawer);



// WEBPACK FOOTER //
// ./src/js/selection/update/SelectionUpdateDrawer.js